var _defs, _rect, _text, _rect2, _text2, _g, _rect3, _text3, _rect4, _text4, _rect5, _text5, _rect6, _text6, _rect7, _text7, _text8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKnowledgeshelf({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 340",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ksBg",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0f172a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#1e1b4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#090d16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nodeGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#6366f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#a855f7"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 340,
    fill: "url(#ksBg)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 48,
    fill: "#f8fafc",
    fontFamily: "system-ui, -apple-system, sans-serif",
    fontSize: 20,
    fontWeight: 800,
    letterSpacing: -0.5
  }, "KnowledgeShelf")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 32,
    width: 130,
    height: 22,
    rx: 11,
    fill: "rgba(99,102,241,0.15)",
    stroke: "rgba(99,102,241,0.3)",
    strokeWidth: 1
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 295,
    y: 47,
    fill: "#818cf8",
    fontFamily: "monospace",
    fontSize: 11,
    fontWeight: 600,
    textAnchor: "middle"
  }, "knowledgeshelf.site")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "rgba(99,102,241,0.3)",
    strokeWidth: 2,
    strokeDasharray: "4 4"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 130,
    x2: 300,
    y2: 100
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 100,
    x2: 460,
    y2: 130
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 130,
    x2: 220,
    y2: 210
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 100,
    x2: 300,
    y2: 210
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 130,
    x2: 380,
    y2: 210
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 210,
    x2: 380,
    y2: 210
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 105,
    width: 140,
    height: 46,
    rx: 8,
    fill: "#1e1b4b",
    stroke: "#6366f1",
    strokeWidth: 1.5
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 140,
    y: 132,
    fill: "#c7d2fe",
    fontFamily: "monospace",
    fontSize: 12,
    fontWeight: 600,
    textAnchor: "middle"
  }, "System Design")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 75,
    width: 140,
    height: 46,
    rx: 8,
    fill: "#1e1b4b",
    stroke: "#8b5cf6",
    strokeWidth: 1.5
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 102,
    fill: "#e0e7ff",
    fontFamily: "monospace",
    fontSize: 12,
    fontWeight: 600,
    textAnchor: "middle"
  }, "Distributed Systems")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 390,
    y: 105,
    width: 140,
    height: 46,
    rx: 8,
    fill: "#1e1b4b",
    stroke: "#ec4899",
    strokeWidth: 1.5
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 460,
    y: 132,
    fill: "#fbcfe8",
    fontFamily: "monospace",
    fontSize: 12,
    fontWeight: 600,
    textAnchor: "middle"
  }, "Data Engineering")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 185,
    width: 140,
    height: 46,
    rx: 8,
    fill: "#1e1b4b",
    stroke: "#3b82f6",
    strokeWidth: 1.5
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 212,
    fill: "#bfdbfe",
    fontFamily: "monospace",
    fontSize: 12,
    fontWeight: 600,
    textAnchor: "middle"
  }, "DSA &amp; Algos")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 185,
    width: 140,
    height: 46,
    rx: 8,
    fill: "#1e1b4b",
    stroke: "#10b981",
    strokeWidth: 1.5
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 380,
    y: 212,
    fill: "#a7f3d0",
    fontFamily: "monospace",
    fontSize: 12,
    fontWeight: 600,
    textAnchor: "middle"
  }, "AI / ML &amp; Quant")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 300,
    fill: "#94a3b8",
    fontFamily: "monospace",
    fontSize: 12
  }, "Interactive Technical Learning Engine &amp; Engineering Collection")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledgeshelf);
export default __webpack_public_path__ + "static/media/knowledgeshelf.2b41577a25cee418d7a86ecb9476ac04.svg";
export { ForwardRef as ReactComponent };